module.exports = __webpack_public_path__ + "static/media/online-king.cc9718b9.png";